import styled from "styled-components";

export const StyledRefundDetails = styled.div`
  margin: 1rem 0px;
  padding: 1rem;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: ${(props) => (props.roundedEdgeButtons ? "10px" : "0px")};

  .refund-details-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .refund-amount {
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }

  .refund-details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .refund-title {
    display: flex;
    align-items: center;
  }

  .refund-time {
    font-size: 10px;
    text-align: right;
  }

  .refund-mode {
    text-transform: capitalize;
    display: flex;
    align-items: center;
    font-size: 10px;

    span {
      margin-top: 2px;
      margin-left: 4px;
    }
  }

  .refund-status {
    font-size: 10px;
    text-transform: capitalize;
    margin-left: 10px;
    padding: 4px 10px;
    border-radius: ${(props) => (props.roundedEdgeButtons ? "10px" : "0px")};
    background: ${(props) =>
      props?.refundStatus?.includes("completed") ||
      props?.refundStatus?.includes("processed") ||
      props?.refundStatus?.includes("redeemed")
        ? "#DEF8E4"
        : props?.refundStatus?.includes("fail") ||
          props?.refundStatus?.includes("expired") ||
          props?.refundStatus?.includes("cancelled") ||
          props?.refundStatus?.includes("deactivate") ||
          props?.refundStatus?.includes("reversal")
        ? "#F9C8C8"
        : "#d9eafe"};
    color: ${(props) =>
      props?.refundStatus?.includes("completed") ||
      props?.refundStatus?.includes("processed") ||
      props?.refundStatus?.includes("redeemed")
        ? "#24A843"
        : props?.refundStatus?.includes("fail") ||
          props?.refundStatus?.includes("expired") ||
          props?.refundStatus?.includes("cancelled") ||
          props?.refundStatus?.includes("deactivate") ||
          props?.refundStatus?.includes("reversal")
        ? "#b81414"
        : "#4273EB"};
  }

  .account-details {
    font-size: 12px;
  }

  hr {
    margin: 6px 0px;
  }

  button {
    font-size: 12px;
  }

  @media (min-width: 800px) {
    padding: 1rem;
    .account-details {
      font-size: 14px;
    }
    .refund-details {
      flex-direction: row;
      align-items: center;
    }
    .refund-amount {
      font-size: 1rem;
    }
    .refund-mode {
      margin-top: 0px;
      margin-left: 10px;
    }
    .refund-time {
      font-size: 12px;
    }
    .refund-status {
      font-size: 12px;
    }
    hr {
      margin: 10px 0px;
    }
    button {
      font-size: 14px;
    }
  }
`;
